import { render, staticRenderFns } from "./TopNoticeBar.vue?vue&type=template&id=4c22c484&scoped=true"
import script from "./TopNoticeBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./TopNoticeBar.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TopNoticeBar.vue?vue&type=style&index=0&id=4c22c484&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c22c484",
  null
  
)

export default component.exports